import React from 'react'
import cn from 'classnames'

import { ParsingHero } from './head/ParsingHero'
import { RepricerHero } from './head/RepricerHero'
import { SiteHeader } from './head/SiteHeader'

const INFO_PAGES = ['/oferta', '/pers', '/about']

const REPRICER_HERO_CONTENT = {
  '/': {
    title: 'AI-Репрайсер',
    subtitle: 'нового поколения',
    description: [
      'Подбирает оптимальную цену,',
      'выполняет план продаж и контролирует маржу'
    ]
  },
  '/video': {
    title: 'Видеообзоры',
    subtitle: 'Прайс Ниндзя',
    minimal: true,
    description: [
      'Познакомьтесь с основными возможностями сервиса',
      ' и посмотрите, как Прайс Ниндзя работает на практике'
    ]
  }
}

const HeadSection = ({ setShowConnectUsModal, url }) => {
  const repricerHeroContent = REPRICER_HERO_CONTENT[url]

  return (
    <div
      className={cn('bg-black', {
        'relative overflow-hidden': url !== '/oferta'
      })}
    >
      <SiteHeader setShowConnectUsModal={setShowConnectUsModal} url={url} />
      {!INFO_PAGES.includes(url) && (
        <>
          {url === '/parsing' && <ParsingHero />}
          {repricerHeroContent && <RepricerHero {...repricerHeroContent} />}
        </>
      )}
    </div>
  )
}

export { HeadSection }
